/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) System Signal Icon component.
 */
export const SystemSignalIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='4' y='20.6367' width='5.59999' height='6.36364' fill={iconColor} />
      <rect x='13' y='18.0908' width='5.59999' height='8.90909' fill={iconColor} />
      <rect x='22' y='15.5449' width='5.59999' height='11.4545' fill={iconColor} />
      <rect x='31' y='13' width='5.59999' height='14' fill={iconColor} />
    </svg>
  );
};

export default SystemSignalIcon;
